import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  /**
   * GET request
   */
  get<T>(endpoint: string, params?: HttpParams): Observable<T> {
    return this.http
      .get<ApiResponse<T>>(`${this.baseUrl}${endpoint}`, { params })
      .pipe(map((response) => response.result));
  }

  /**
   * POST request
   */
  post<T>(endpoint: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http
      .post<ApiResponse<T>>(`${this.baseUrl}${endpoint}`, body, { headers })
      .pipe(map((response) => response.result));
  }

  /**
   * PUT request
   */
  put<T>(endpoint: string, body: any, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    return this.http
      .put<ApiResponse<T>>(`${this.baseUrl}${endpoint}`, body, { headers, params })
      .pipe(map((response) => response.result));
  }

  /**
   * PATCH request
   */
  patch<T>(endpoint: string, body: any): Observable<T> {
    return this.http
      .patch<ApiResponse<T>>(`${this.baseUrl}${endpoint}`, body)
      .pipe(map((response) => response.result));
  }

  /**
   * DELETE request
   */
  delete<T>(endpoint: string): Observable<T> {
    return this.http
      .delete<ApiResponse<T>>(`${this.baseUrl}${endpoint}`)
      .pipe(map((response) => response.result));
  }

  /**
   * Upload file directly to S3 using presigned URL
   * Note: withCredentials is set to false because S3 presigned URLs don't need cookies,
   * and S3 CORS configuration uses wildcard (*) which doesn't work with credentials
   */
  uploadToS3(presignedUrl: string, file: File): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': file.type,
    });
    return this.http.put(presignedUrl, file, {
      headers,
      withCredentials: false,
    });
  }
}
